import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PaymentStatus from "./pages/PaymentStatus";
import Animation from './shared/animation/Animation';

function App() {
  return (
    <div className="min-h-screen relative">
      <Animation />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/:status" element={<PaymentStatus />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;